module.exports = __webpack_public_path__ + "img/pos.485a657e.png";